import React, { useEffect, useState } from 'react'
import { supabase } from 'utils/supabase'
import { useParams } from 'react-router-dom'
import SuccessCandidateForm from 'admin/components/SuccessCandidateForm'
import AdminPageWrapper from 'admin/components/AdminPageWrapper'

const EditSuccessCandidate = () => {
  const [candidate, setCandidate] = useState(undefined)
  const { id } = useParams()

  const fetchCandidate = async () => {
    try {
      const response = await supabase.from('candidates').select().eq('id', id)
      const data = response.data ? response.data[0] : null

      if (data) {
        setCandidate(data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchCandidate()
  }, [id])

  return (
    <AdminPageWrapper>
      <SuccessCandidateForm candidate={candidate} />
    </AdminPageWrapper>
  )
}

export default EditSuccessCandidate
